module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description_of_activity":"The activity for the last month.","sanga":"","commented":"commented.","your_post":"Your post","your_favoraited_post":"Your liked post"}}')
  delete Component.options._Ctor
}
